import React from 'react';
import Hero from '@/components/sections/Hero';
import Benefits from '@/components/sections/Benefits';
import ProductsPreview from '@/components/sections/ProductsPreview';
import CTASection from '@/components/sections/CTASection';
import Seo from '@/components/seo/Seo';
import { content } from '@/content/sr';

const HomePage = () => {
  // Naslovna nosi puno ime firme + delatnost + grad — to je upit po kom se traži.
  const pageTitle = `${content.company.name} — zidni paneli, pergole i enterijer rešenja | Užice`;
  const pageDescription =
    `${content.company.fullName} — ${content.company.description}. Zidni i dekorativni paneli, ` +
    'bioklimatske pergole, stakleni sistemi, nameštaj po meri i prirodni kamen, sa isporukom širom Srbije.';

  return (
    <>
      <Seo title={pageTitle} description={pageDescription} path="/" />

      <div data-testid="home-page">
        <Hero />
        <Benefits />
        <ProductsPreview />
        <CTASection />
      </div>
    </>
  );
};

export default HomePage;
